import {useEffect} from 'react';
import type {HistoryItem} from '@AiChat/ai-chat.types';

interface UseAiChatWindowTitleParams {
  currentChatId: string | undefined;
  chatHistory: HistoryItem[];
  isQuickTipsView: boolean;
}

export function useAiChatWindowTitle({currentChatId, chatHistory, isQuickTipsView}: UseAiChatWindowTitleParams): void {
  useEffect(() => {
    if (isQuickTipsView) {
      document.title = window.i18next.t('pmwjs_ai_quick_tips_window_title');
      return;
    }

    if (!currentChatId) {
      document.title = window.i18next.t('pmwjs_create_with_postermywall_ai');
      return;
    }

    const currentChat = chatHistory.find((chat) => chat.idAiChat === currentChatId);
    document.title = currentChat?.title ?? window.i18next.t('pmwjs_create_with_postermywall_ai');
  }, [currentChatId, chatHistory, isQuickTipsView]);
}
